import React from 'react';


function RightSection( { imageUrl, productName, productDescription, learnMore } ) {
  return (
<div className="container mt-5 ">
      <div className="row ">

        <div className="col-6 p-5 mt-5">
          <h1>{productName}</h1>
          <p>{productDescription}</p>
          <div>

            <a href={learnMore} className="btn btn-outline-primary m-2" style={{marginleft:"50px"}}>
              Learn More
            </a>
          </div>


        </div>
     <div className="col-6 p-5">
          <img src={imageUrl} alt={productName} className="img-fluid" />
        </div>
      </div>
    </div>
  );
}

export default RightSection;